import { Base } from "../../framework/base";
import { ListItems } from "../../framework/listItems";
import { AppReportListItem, IAppReportListItem } from "./appReportListItem";

export interface IAppReportListItems extends ListItems<IAppReportListItem> {
}

export class AppReportListItems extends ListItems<AppReportListItem> implements IAppReportListItems {
    constructor();
    constructor(obj: IAppReportListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, AppReportListItem);
    }
}